import { render } from "./ProfileAssignmentDialog.vue?vue&type=template&id=f7af615e"
import script from "./ProfileAssignmentDialog.vue?vue&type=script&lang=js"
export * from "./ProfileAssignmentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__